/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SoftUIControllerProvider } from "context";
import { AuthProvider } from "layouts/auth/AuthContext";
import App from "App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <SoftUIControllerProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </SoftUIControllerProvider>
    </BrowserRouter>
  </React.StrictMode>
);
